import { termsOfServiceMarkdown } from "@canucci/base";
import { Container } from "@mantine/core";
import { StyledMarkdown } from "./StyledMarkdown";

export function TermsOfServicePage({
  accentHorizontalRules = false,
  accentDocumentTitle = false,
  accentEmailLinks = false,
}: {
  accentHorizontalRules?: boolean;
  accentDocumentTitle?: boolean;
  accentEmailLinks?: boolean;
}) {
  return (
    <Container maw="48rem" py="xl">
      <StyledMarkdown
        content={termsOfServiceMarkdown}
        accentHorizontalRules={accentHorizontalRules}
        accentDocumentTitle={accentDocumentTitle}
        accentEmailLinks={accentEmailLinks}
      />
    </Container>
  );
}
